import { Button, Stack, Typography } from '@mui/material';
import { Edit, RemoveRedEye } from '@mui/icons-material';
import { DealBuilderStep } from '../../../../types';
import { DealBuilderQuote, DealBuilderEntity } from 'modules/dealBuilder/api';
import { ActionsMenu } from 'components/shared/Menu/ActionsMenu';
import { useDealProposalPreview } from 'modules/dealBuilder/hooks/useDealProposalPreview';
import { useGoToDealBuilderStep } from '../../../../hooks';
import { Nullable } from 'global';

interface Props {
  activeEntity: Nullable<DealBuilderEntity>;
  quote: Nullable<DealBuilderQuote>;
}

export const DealDetailsHeader = ({ activeEntity, quote }: Props) => {
  const { handlePreviewFromDealSummary } = useDealProposalPreview();
  const goToStep = useGoToDealBuilderStep();

  const handleSendQuote = () => {
    goToStep(quote?.equipment ? DealBuilderStep.ReviewSend : DealBuilderStep.Contacts);
  };

  const handleEdit = () => {
    goToStep(quote?.equipment ? DealBuilderStep.Pricing : DealBuilderStep.Contacts);
  };

  const handlePreview = async () => {
    const linkToProposalPage = await handlePreviewFromDealSummary(activeEntity!);
    if (linkToProposalPage) {
      window.open(linkToProposalPage, '_blank');
    }
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Typography variant="subtitle1" fontWeight={500}>
        Deal Details
      </Typography>
      <Stack direction="row" alignItems="center" gap={1}>
        <Button variant="contained" size="small" onClick={handleSendQuote}>
          Send Quote
        </Button>
        <ActionsMenu
          config={[
            {
              action: handleEdit,
              label: 'Edit',
              icon: <Edit color="primary" />,
            },
            {
              action: handlePreview,
              label: 'Preview',
              icon: <RemoveRedEye color="primary" />,
              disabled: !activeEntity,
            },
          ]}
        />
      </Stack>
    </Stack>
  );
};
